import { Box, Group, Progress, Stack, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import type { IResolutionHistogramBucket } from "../../apis/return-analytics";

interface Props {
  buckets: IResolutionHistogramBucket[];
}

export function ResolutionTimeHistogram({ buckets }: Props) {
  const { t } = useTranslation("returns");
  const total    = buckets.reduce((sum, b) => sum + b.count, 0);
  const maxCount = buckets.length > 0 ? Math.max(...buckets.map((b) => b.count), 1) : 1;

  if (total === 0) {
    return (
      <Text ta="center" c="dimmed" size="sm" py="xl">
        {t("common.noData")}
      </Text>
    );
  }

  return (
    <Stack gap="xs">
      <Text size="sm" c="dimmed" mb={4}>
        {t("dashboard.resolutionHistogram.summary", { count: total })}
      </Text>

      {buckets.map((b) => {
        const barValue = maxCount > 0 ? (b.count / maxCount) * 100 : 0;
        const pct      = total  > 0 ? ((b.count / total) * 100).toFixed(1) : "0.0";

        return (
          <Box key={b.key}>
            <Group justify="space-between" mb={4} gap="xs">
              <Text size="sm" fw={500} w={90}>
                {b.label}
              </Text>
              <Group gap={6}>
                <Text size="sm" c="dimmed" ta="right" w={40}>
                  {b.count}
                </Text>
                <Text size="sm" c="dimmed" ta="right" w={44}>
                  {pct}%
                </Text>
              </Group>
            </Group>
            <Progress
              value={barValue}
              color="blue"
              size="md"
              radius="xl"
            />
          </Box>
        );
      })}
    </Stack>
  );
}
